import moment from "moment";
import warehouseService from "@/services/warehouse"; // add this import
import groceryService from "@/services/grocery";

const state = () => ({
  items: [],
  inventory: [],
  groceries: [],
  filters: {
    search: "",
    warehouse: [],
    dates: {
      from: moment().format("YYYY-MM-DD"),
      to: moment().format("YYYY-MM-DD"),
    },
    showType: "daily",
    documentType: null,
    groceryCode: null,
    status: null,
    suppliers: [],
    selectedShifts: [1, 2, 3],
  },
  loading: false,
  error: null,
  transactions: [],
  suppliers: [],
  refreshTrigger: 0,
});

const mutations = {
  SET_ITEMS(state, items) {
    state.items = items;
  },
  SET_INVENTORY(state, inventory) {
    state.inventory = inventory;
  },
  SET_GROCERIES(state, groceries) {
    state.groceries = groceries;
  },
  SET_FILTER(state, { key, value }) {
    state.filters[key] = value;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_SUPPLIERS(state, suppliers) {
    state.filters.suppliers = suppliers;
    state.suppliers = suppliers;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_DATE(state, dates) {
    state.filters.dates.from = dates[0];
    state.filters.dates.to = dates[1];
  },
  SET_TRANSACTIONS(state, transactions) {
    state.transactions = transactions;
  },
  TRIGGER_REFRESH(state) {
    state.refreshTrigger++;
  },
};

const actions = {
  async fetchItems({ commit, state }) {
    // Return current warehouses if already loaded
    if (state.items && state.items.length > 0) {
      return state.items;
    }
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);
    try {
      const response = await warehouseService.getWarehouses();
      commit("SET_ITEMS", response.data);
      return response.data;
    } catch (e) {
      commit("SET_ERROR", e);
      return [];
    } finally {
      commit("SET_LOADING", false);
    }
  },
  async fetchInventory({ commit, state }, force = false) {
    // Return current inventory if already loaded and not forcing refresh
    if (!force && state.inventory && state.inventory.length > 0) {
      return state.inventory;
    }
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);
    try {
      const response = await warehouseService.getInventory();
      commit("SET_INVENTORY", response.data);
      return response.data;
    } catch (e) {
      commit("SET_ERROR", e);
      return [];
    } finally {
      commit("SET_LOADING", false);
    }
  },
  async fetchGroceries({ commit, state }, force = false) {
    // Return current groceries if already loaded and not forcing refresh
    if (!force && state.groceries && state.groceries.length > 0) {
      return state.groceries;
    }
    
    commit("SET_ERROR", null);
    try {
      const response = await groceryService.getWarehouseGroceries();
      commit("SET_GROCERIES", response.data);
      return response.data;
    } catch (e) {
      commit("SET_ERROR", e);
      return [];
    }
  },
  async fetchSuppliers({ commit, state }) {
    // Return current suppliers if already loaded
    if (state.suppliers && state.suppliers.length > 0) {
      return state.suppliers;
    }
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);
    try {
      const response = await warehouseService.getSuppliers();
      commit("SET_SUPPLIERS", response.data);
      return response.data;
    } catch (e) {
      commit("SET_ERROR", e);
      return [];
    } finally {
      commit("SET_LOADING", false);
    }
  },
  setFilter({ commit, dispatch }, { key, value }) {
    commit("SET_FILTER", { key, value });
    dispatch("fetchItems");
  },
};

const getters = {
  filteredItems: (state) => {
    let items = state.items;
    if (state.filters.search) {
      items = items.filter((item) =>
        item.name.toLowerCase().includes(state.filters.search.toLowerCase())
      );
    }
    if (state.filters.category) {
      items = items.filter((item) => item.category === state.filters.category);
    }
    if (state.filters.inStock !== null) {
      items = items.filter((item) => item.inStock === state.filters.inStock);
    }
    return items;
  },
  filters: (state) => state.filters,
  loading: (state) => state.loading,
  error: (state) => state.error,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
